var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('div',{staticClass:"menu__btn",on:{"click":function($event){_vm.isOpen=!_vm.isOpen}}},[_c('svg',{staticClass:"hamburger",attrs:{"viewBox":"0 0 100 100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('mask',{attrs:{"id":"mask"}},[_c('rect',{attrs:{"x":"0","y":"0","width":"100","height":"100","fill":"white"}}),_vm._l((3),function(n){return _c('rect',{key:'buns'+n,class:{
                'hamburger__buns': true,
                'hamburger__buns--open': _vm.isOpen,
              },attrs:{"width":"55","height":"10","x":"22.5","y":20*n+5,"rx":"5","ry":"10","fill":"black"}})}),_c('rect',{class:{
                'hamburger__cross': true,
                'hamburger__cross-1': true,
                'hamburger__cross-1--open': _vm.isOpen,
              },attrs:{"width":"55","height":"10","x":"22.5","y":"45","rx":"5","ry":"10","fill":"black"}}),_c('rect',{class:{
                'hamburger__cross': true,
                'hamburger__cross-2': true,
                'hamburger__cross-2--open': _vm.isOpen,
              },attrs:{"width":"55","height":"10","x":"22.5","y":"45","rx":"5","ry":"10","fill":"black"}})],2),_c('circle',{attrs:{"cx":"50","cy":"50","r":"50","mask":"url(#mask)"}})])]),_c('div',{class:{
      'menu__content': true,
      'menu__content--open': _vm.isOpen,
    },on:{"click":function($event){_vm.isOpen=false}}},[_c('div',{class:{
      'menu__line': true,
      'menu__line--open': _vm.isOpen,
    }}),_c('ul',{staticClass:"menu__navs"},[_c('li',{class:{
          'menu__nav': true,
          'menu__nav--1': true,
          'animate': _vm.isOpen,
        }},[_c('a',{attrs:{"href":"#about-section"}},[_vm._v("About")]),_c('svg',{class:{
          'menu__circle': true,
          'animate': _vm.isOpen,
        },attrs:{"viewBox":"0 0 100 100"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"50","fill":"#fff"}})])]),_c('li',{class:{
          'menu__nav': true,
          'menu__nav--2': true,
          'animate': _vm.isOpen,
        }},[_c('a',{attrs:{"href":"#works-section"}},[_vm._v("Works")]),_c('svg',{class:{
          'menu__circle': true,
          'animate': _vm.isOpen,
        },attrs:{"viewBox":"0 0 100 100"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"50","fill":"#fff"}})])]),_c('li',{class:{
          'menu__nav': true,
          'menu__nav--3': true,
          'animate': _vm.isOpen,
        }},[_c('a',{attrs:{"href":"#contact-section"}},[_vm._v("Contact")]),_c('svg',{class:{
          'menu__circle': true,
          'animate': _vm.isOpen,
        },attrs:{"viewBox":"0 0 100 100"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"50","fill":"#fff"}})])]),_c('li',{class:{
          'menu__nav': true,
          'menu__nav--btt': true,
          'animate': _vm.isOpen,
        }},[_c('a',{attrs:{"href":"#"}},[_vm._v("back to top")]),_c('svg',{class:{
          'menu__circle': true,
          'animate': _vm.isOpen,
        },attrs:{"viewBox":"0 0 100 100"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"50","fill":"#fff"}})])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }